var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form"
  }, [(_vm.error) ? _c('p', {
    staticClass: "message message-error ss-alert"
  }, [_vm._v("\n    " + _vm._s(_vm.error.message) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('Toggle', {
    attrs: {
      "options": [{
          value: 'fieldtrips_once',
          label: 'Just once'
        },
        {
          value: 'fieldtrips_monthly',
          label: 'Give monthly'
        }
      ],
      "name": "plan_id"
    },
    model: {
      value: (_vm.plan_id),
      callback: function($$v) {
        _vm.plan_id = $$v
      },
      expression: "plan_id"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "amounts"
  }, [_vm._l((_vm.amountOptions), function(option) {
    return _c('div', {
      staticClass: "amount"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.currentRadio),
        expression: "currentRadio"
      }],
      attrs: {
        "name": "price",
        "id": option,
        "type": "radio"
      },
      domProps: {
        "value": option,
        "checked": _vm._q(_vm.currentRadio, option)
      },
      on: {
        "__c": function($event) {
          _vm.currentRadio = option
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "cm-button",
      attrs: {
        "for": option
      },
      on: {
        "click": function($event) {
          _vm.isCustomChecked = false
        }
      }
    }, [_vm._v("$" + _vm._s(option))])])
  }), _vm._v(" "), _c('div', {
    staticClass: "custom-amount"
  }, [_c('span', {
    staticClass: "icon"
  }, [_vm._v("$")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "radio",
      "name": "price",
      "id": ""
    },
    domProps: {
      "value": _vm.customAmount,
      "checked": _vm.isCustomChecked
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customAmount),
      expression: "customAmount"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.customAmountPlaceholder
    },
    domProps: {
      "value": (_vm.customAmount)
    },
    on: {
      "click": function($event) {
        _vm.isCustomChecked = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.customAmount = $event.target.value
      }
    }
  })])], 2), _vm._v(" "), _c('div', {
    attrs: {
      "id": "dropin-container"
    }
  }), _vm._v(" "), _c('input', {
    ref: "nonceInput",
    attrs: {
      "type": "hidden",
      "name": "nonce"
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3337b237","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/donation-form.vue
// module id = null
// module chunks = 